import { useEffect,useRef, useMemo, useState } from "react";
import {
    Box,
    HStack,
    Text,
    VStack,
    Button,
    Flex
} from "@chakra-ui/react";
import "mapbox-gl/dist/mapbox-gl.css";
import Map, {
    NavigationControl,
} from "react-map-gl/mapbox";

import {
    Navigation,
} from "lucide-react";

import Card from "../../Dashboard/components/Card";



const DriverLocations = ({
     driverDetails = [],
}) => {
    const mapRef =
        useRef(null);

    const [
        expanded,
        setExpanded,
    ] = useState(false);

const locations =
    useMemo(
        () =>
            driverDetails
                .filter(
                    driver =>
                        driver.driver_lat &&
                        driver.driver_lon
                )
                .map(
                    driver => ({
                        city:
                            driver.user
                                ?.village ||
                            driver.user
                                ?.district ||
                            "Unknown",

                        district:
                            driver.user
                                ?.district,

                        lat: Number(
                            driver.driver_lat
                        ),

                        lng: Number(
                            driver.driver_lon
                        ),

                        drivers: 1,
                    })
                ),
        [driverDetails]
    );

    useEffect(() => {
    const map =
        mapRef.current?.getMap();

    if (
        !map ||
        !map.getSource("drivers")
    ) {
        return;
    }

    const geojson = {
        type: "FeatureCollection",
        features: locations.map(
            location => ({
                type: "Feature",
                properties: {
                    drivers:
                        location.drivers,
                },
                geometry: {
                    type: "Point",
                    coordinates: [
                        location.lng,
                        location.lat,
                    ],
                },
            })
        ),
    };

    map.getSource(
        "drivers"
    ).setData(
        geojson
    );
}, [locations]);

    const citySummary =
        useMemo(() => {
            return Object.values(
                locations.reduce(
                    (
                        acc,
                        item
                    ) => {
                        if (
                            !acc[
                                item.city
                            ]
                        ) {
                           acc[item.city] = {
    city:
        item.city,
    district:
        item.district,
    drivers: 0,
};
                        }

                        acc[
                            item.city
                        ].drivers++;

                        return acc;
                    },
                    {}
                )
            ).sort(
                (
                    a,
                    b
                ) =>
                    b.drivers -
                    a.drivers
            );
        }, [
            locations,
        ]);

    const displayedCities =
        useMemo(
            () =>
                expanded
                    ? citySummary
                    : citySummary.slice(
                          0,
                          5
                      ),
            [
                expanded,
                citySummary,
            ]
        );
       
    return (
        <Card>
            <HStack
                justify="space-between"
                mb={8}
            >
                <Box>
                    <Text
                        fontSize="2xl"
                        fontWeight="700"
                        color="#071D54"
                    >
                        Recruited Driver Distribution
                    </Text>

                    <Text color="gray.500">
                        My recruited drivers across Botswana
                    </Text>
                </Box>

                <Navigation
                    color="#2453FF"
                    size={24}
                />
            </HStack>

            <Flex
                align="stretch"
                gap={6}
                flexDir={{
                    base: "column",
                    xl: "row",
                }}
            >
                <Box
                    flex="1"
                    minH={{
                        base: "320px",
                        md: "400px",
                        xl: "500px",
                    }}
                    h={{
                        base: "320px",
                        md: "400px",
                        xl: "500px",
                    }}
                    w="100%"
                    borderRadius="20px"
                    overflow="hidden"
               
                >
               

                <Map
                 
                    ref={mapRef}
                    mapboxAccessToken={
                        process.env.REACT_APP_MAPBOX_TOKEN
                    }
                    initialViewState={{
                        longitude: 24.68,
                        latitude: -22.3,
                        zoom: 5.6,
                    }}
                    mapStyle="mapbox://styles/mapbox/light-v11"
                    style={{
                        width: "100%",
                        height:
                            window.innerWidth < 768
                                ? "280px"
                                : window.innerWidth < 1280
                                ? "600px"
                                : "700px",
                    }}
                                    
                    onLoad={(e) => {
                        const map = e.target;
                        setTimeout(() => {
                        map.resize();
                    }, 100);
                        const geojson = {
                            type: "FeatureCollection",
                            features: locations.map(
                                (location) => ({
                                    type: "Feature",
                                    properties: {
                                        drivers:
                                            location.drivers,
                                    },
                                    geometry: {
                                        type: "Point",
                                        coordinates: [
                                            location.lng,
                                            location.lat,
                                        ],
                                    },
                                })
                            ),
                        };

                        if (
                            map.getSource("drivers")
                        )
                          return;

                    map.addSource("drivers", {
                        type: "geojson",
                        data: geojson,
                    });

                    map.addLayer({
                        id: "driver-heat",
                        type: "heatmap",
                        source: "drivers",
                        maxzoom: 10,
                        paint: {
                           "heatmap-weight": [
                            "interpolate",
                            ["linear"],
                            ["get", "drivers"],
                            0, 0,
                            1, 0.5,
                            2, 0.75,
                            5, 1,
                        ],

                            "heatmap-intensity": [
                                "interpolate",
                                ["linear"],
                                ["zoom"],
                                0,
                                1,
                                9,
                                3,
                            ],

                           "circle-radius": [
                            "interpolate",
                            ["linear"],
                            ["get", "drivers"],
                            1, 6,
                            5, 12,
                            10, 18,
                        ],

                            "heatmap-opacity": 0.85,

                            "heatmap-color": [
                                "interpolate",
                                ["linear"],
                                ["heatmap-density"],

                                0,
                                "rgba(36,83,255,0)",

                                0.2,
                                "#C7D8FF",

                                0.4,
                                "#8FB2FF",

                                0.6,
                                "#5F8FFF",

                                0.8,
                                "#2453FF",

                                1,
                                "#071D54",
                            ],
                        },
                    });

                    map.addLayer({
                        id: "driver-points",
                        type: "circle",
                        source: "drivers",
                        minzoom: 8,
                        paint: {
                            "circle-radius": [
                                "interpolate",
                                ["linear"],
                                ["get", "drivers"],
                                500,
                                6,
                                3500,
                                18,
                            ],

                            "circle-color":
                                "#2453FF",

                            "circle-stroke-width": 2,

                            "circle-stroke-color":
                                "#FFFFFF",

                            "circle-opacity": [
                                "interpolate",
                                ["linear"],
                                ["zoom"],
                                8,
                                0,
                                9,
                                1,
                            ],
                        },
                    });
                }}
            >
                <NavigationControl position="top-right" />
            </Map>
                </Box>

             <VStack
    w={{
        base: "100%",
        xl: "320px",
    }}
    gap={4}
    align="stretch"
>
    {displayedCities.map((location) => (
        <Box
            key={location.city}
            p={4}
            borderRadius="16px"
            bg="gray.50"
        >
            <HStack justify="space-between">
                <Box>
    <Text
        fontWeight="700"
        color="#071D54"
    >
        {location.city}
    </Text>

    {location.district &&
        location.city !==
            location.district && (
            <Text
                fontSize="xs"
                color="gray.500"
            >
                {location.district}
            </Text>
        )}
</Box>

                <Text
                    fontWeight="700"
                    color="#2453FF"
                >
                    {location.drivers.toLocaleString()}
                </Text>
            </HStack>

            <Text
                mt={1}
                fontSize="sm"
                color="gray.500"
            >
                Recruited Drivers
            </Text>
        </Box>
            ))}

            {citySummary.length > 5 && (
                <Button
                    variant="ghost"
                    color="#2453FF"
                    fontWeight="600"
                    onClick={() =>
                        setExpanded(!expanded)
                    }
                >
                    {expanded
                        ? "Show Less"
                        : `Show ${
                            citySummary.length - 5
                        } More`}
                </Button>
            )}
        </VStack>
            </Flex>
        </Card>
    );
};

export default DriverLocations;